import React, { useContext } from 'react'
import { Form, Input } from 'semantic-ui-react'

import { QuestionBuilderContext } from 'organisms/QuestionBuilderCard'

export default function RatingScaleMinmaxQuestionInput() {
  const { handleFieldChange, question } = useContext(QuestionBuilderContext)

  return (
    <Form.Group widths="equal" className="field">
      <Form.Field>
        <label>Min score</label>
        <Input
          className="large"
          required
          value={question.leftSideLabel}
          onChange={handleFieldChange('leftSideLabel')}
        />
      </Form.Field>
      <Form.Field>
        <label>Max score</label>
        <Input
          className="large"
          required
          value={question.rightSideLabel}
          onChange={handleFieldChange('rightSideLabel')}
        />
      </Form.Field>
    </Form.Group>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/RatingScaleMinmaxQuestionInput/index.js